export default __webpack_public_path__ + "static/media/cycle.d96ae545.png";